import {
  pixTransactionsListFactory,
  pixTransactionsResumeFactory,
} from 'factories';
import { requestAxios } from 'services';
import {
  PixTransactionsListParams,
  PixTransactionsListResponse,
  PixTransactionsResume,
} from 'types';

async function getResume(): Promise<PixTransactionsResume> {
  let result: any = {};

  try {
    const response = await requestAxios.get(
      'reports/admin/pix/transactions/resume'
    );
    result = response.data;
  } catch (error) {
    console.error(error);
  }

  return pixTransactionsResumeFactory(result);
}

async function getTransactions(
  params: PixTransactionsListParams
): Promise<PixTransactionsListResponse> {
  let result: any = {};

  try {
    const response = await requestAxios.get('reports/admin/pix/transactions', {
      params,
    });
    result = response.data;
  } catch (error) {
    console.error(error);
  }

  return pixTransactionsListFactory(result);
}

export const pixTransactionsService = {
  getResume,
  getTransactions,
};
